export enum ResourceType {
  'HTML' = 'HTML',
  'PDF' = 'PDF',
  'VIDEO_LINK' = 'VIDEO_LINK',
}
